const swiperElements = document.querySelectorAll('.nxt-swiper')

swiperElements.forEach(swiperElement => {
  // Extract data attributes
  const autoplay = swiperElement.dataset.autoplay === 'true'
  const autoplaySpeed = parseInt(swiperElement.dataset.autoplaySpeed, 10)
  const slidesPerView = parseInt(
    swiperElement.dataset.slidesPerView,
    10
  )

  const breakpoints = JSON.parse(swiperElement.dataset.breakpoints)

  const navigation = swiperElement.dataset.navigation === 'true'
  const keyboard = swiperElement.dataset.keyboard === 'true'
  const direction = swiperElement.dataset.direction
  const pagination = swiperElement.dataset.pagination === 'true'
  const paginationDynamic = swiperElement.dataset.paginationDynamic === 'true'
  const scrollbar = swiperElement.dataset.scrollbar === 'true'
  const autoHeight = swiperElement.dataset.autoheight === 'true'
  const mousewheel = swiperElement.dataset.mousewheel === 'true'
  const animationSpeed = swiperElement.dataset.speed
  
  // Try to get spacing from either data-space-between or data-spacing
  let spaceBetween;
  if ('spaceBetween' in swiperElement.dataset) {
    spaceBetween = parseInt(swiperElement.dataset.spaceBetween, 10);
  } else if ('spacing' in swiperElement.dataset) {
    spaceBetween = parseInt(swiperElement.dataset.spacing, 10);
  } else {
    // Default value
    spaceBetween = 20;
  }
  // console.log('Spacing value used:', spaceBetween);
  
  // Check for spacing in the HTML output
  const allAttributes = Object.keys(swiperElement.dataset);
  // console.log('All data attributes:', allAttributes);
  
  const height = convertToPixels(swiperElement.dataset.height)
  const loop = swiperElement.dataset.loop === 'true'

  const config = {
    autoHeight: autoHeight,
    loop: loop,
    a11y: true,
    speed: animationSpeed ? animationSpeed : 2500,
    spaceBetween: isNaN(spaceBetween) ? 20 : spaceBetween,
    slidesPerView: slidesPerView,
    keyboard: keyboard,
    direction: direction
  }

  if (height) {
    config.height = height
  }

  if (autoplay) {
    config.autoplay = {
      delay: autoplaySpeed ? autoplaySpeed : 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }
  }

  if (navigation) {
    config.navigation = {
      enabled: true,
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  }

  if (scrollbar) {
    config.scrollbar = {
      enabled: true,
      el: '.swiper-scrollbar',
      draggable: true
    }
  }

  if (pagination) {
    config.pagination = {
      enabled: true,
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
    
    // Add dynamic bullets if enabled
    if (paginationDynamic) {
      config.pagination.dynamicBullets = true
      config.pagination.dynamicMainBullets = 5
    }
  }

  if (mousewheel) {
    config.mousewheel = {
      enabled: true,
      sensitivity: 0.5,
      threshold: 50,
      thresholdTime: 200
    }
  }

  if (breakpoints) {
    config.breakpoints = {}
    breakpoints?.forEach(breakpoint => {
      config.breakpoints[`${breakpoint.breakpoint}`] = {
        slidesPerView: parseInt(breakpoint.slides_per_view, 10)
      }
    })
  }

  const swiper = new Swiper(swiperElement, config)
  // console.log('Swiper initialized with config:', config);
})

function convertToPixels (value) {
  const element = document.createElement('div')
  element.style.position = 'absolute'
  element.style.visibility = 'hidden'
  element.style.height = value
  document.body.appendChild(element)
  const pixels = element.offsetHeight
  document.body.removeChild(element)
  return pixels
}
